// extracted by mini-css-extract-plugin
export default {"disabledTenant":"TenantEntry_disabledTenant__5-8JZ"};